
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import noTranslations from './locales/no.json';
import enTranslations from './locales/en.json';

const resources = {
  no: {
    translation: noTranslations
  },
  en: {
    translation: enTranslations
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    lng: 'no', // default language
    
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false,
    },
    
    debug: false, // Disable debug mode for production
  });

// Etter i18n.init(...)
(i18n as any).on('languageChanged', (lng: string) => {
  console.log('[i18n] languageChanged ->', lng);
});
(i18n as any).on('loaded', (arg: any) => {
  console.log('[i18n] loaded bundles', arg);
});
console.log('[i18n] init language =', i18n.language);

// eksponer for konsolltesting
(window as any).i18n = i18n;

export default i18n;
